var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.511,
    height: 64.511,
    viewBox: "0 0 64.511 64.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 64.511,
    height: 64.511,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M18.933,35.64A9.937,9.937,0,1,0,28.871,25.7a9.937,9.937,0,0,0-9.938,9.937m17.783,0A7.846,7.846,0,1,1,28.871,27.8a7.854,7.854,0,0,1,7.845,7.845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M13.9,41.348a2.092,2.092,0,0,0-.319,4.172l.065.005c.05,0,.1,0,.149,0a2.092,2.092,0,0,0,.144-4.179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M6.393,41.379a2.092,2.092,0,0,0,3.325-2.54l-.056-.074a2.092,2.092,0,1,0-3.35,2.507l.081.107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M7.263,33.368l-.012-.051a2.092,2.092,0,1,0-4.07.972l.012.05a2.092,2.092,0,0,0,4.07-.971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M29.936,51.711l-.016.039a2.092,2.092,0,1,0,3.872,1.586l.024-.058a2.092,2.092,0,1,0-3.88-1.567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M26.241,54.951l-.086.03A2.092,2.092,0,1,0,27.5,58.942l.128-.044a2.092,2.092,0,1,0-1.389-3.947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M20.232,55.591a2.092,2.092,0,1,0-.331,4.171l.049,0c.055,0,.109.006.166.006a2.092,2.092,0,0,0,.161-4.177Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M47.47,36.536l-.053-.044A2.092,2.092,0,1,0,44.733,39.7l.027.023a2.092,2.092,0,1,0,2.71-3.188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M50.856,44.249l0-.136a2.093,2.093,0,0,0-4.184.1l0,.091a2.091,2.091,0,0,0,2.091,2.063h.028a2.092,2.092,0,0,0,2.064-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M45.442,50.082l-.021.051a2.092,2.092,0,1,0,3.865,1.6l.018-.045a2.092,2.092,0,0,0-3.862-1.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M36.773,22.235a2.079,2.079,0,0,0,1.11-.32l.031-.02a2.092,2.092,0,1,0-2.2-3.56l-.058.036a2.092,2.092,0,0,0,1.114,3.864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M60.3,18.769a1.457,1.457,0,0,0-.941-.724c-2.11-.51-5.043-2.371-7.784-5.113s-4.6-5.674-5.113-7.784a1.461,1.461,0,0,0-.723-.941A35.488,35.488,0,0,0,30.372,0a1.447,1.447,0,0,0-1.5,1.448V11.865a4.228,4.228,0,0,0,3.475,4.171,19.877,19.877,0,0,1,6.53,2.354A20.045,20.045,0,0,1,46.044,25.5a19.883,19.883,0,0,1,2.422,6.637,4.239,4.239,0,0,0,4.173,3.5H63.062a1.447,1.447,0,0,0,1.448-1.5A35.48,35.48,0,0,0,60.3,18.769M31.532,3.128l-.018.011A1.2,1.2,0,1,1,30.236,1.1l.033-.021a1.2,1.2,0,1,1,1.263,2.045M63.039,34.582l-.018.011a1.2,1.2,0,0,1-1.277-2.035l.033-.021a1.2,1.2,0,0,1,1.262,2.045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M14.776,23.891l.011.045,2.033-.491-2.03.5a2.091,2.091,0,0,0,2.029,1.591,2.122,2.122,0,0,0,.5-.061,2.092,2.092,0,0,0,1.53-2.533l0-.01L18.84,22.9a2.092,2.092,0,0,0-4.064,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M17.025,18.678a2.09,2.09,0,0,0,2.91-.534l.051-.073a2.092,2.092,0,0,0-3.416-2.416l-.079.113a2.092,2.092,0,0,0,.534,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M23.291,14.427a2.082,2.082,0,0,0,1.089-.307l.038-.024a2.092,2.092,0,1,0-2.17-3.577l-.05.03a2.093,2.093,0,0,0,1.093,3.878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M53.546,46.063a26.8,26.8,0,1,1-25.2-37.195V6.776A28.87,28.87,0,1,0,57.735,36.163H55.643a26.589,26.589,0,0,1-2.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M14.645,35.64A14.226,14.226,0,1,0,28.871,21.414,14.242,14.242,0,0,0,14.645,35.64m26.36,0A12.134,12.134,0,1,1,28.871,23.506,12.134,12.134,0,0,1,41.005,35.64"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrake);
export default __webpack_public_path__ + "static/media/brake.826da244ffdb634c3d122772ced02ba8.svg";
export { ForwardRef as ReactComponent };